module.exports = __webpack_public_path__ + "assets/img/8c6746bb94dcd35cbacf7c150d067a35.png";